import { render, staticRenderFns } from "./InvoiceCrud.vue?vue&type=template&id=1c499b37&"
import script from "./InvoiceCrud.vue?vue&type=script&lang=js&"
export * from "./InvoiceCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports